document.addEventListener('DOMContentLoaded', function () {
  const countrySelectorContainers = document.querySelectorAll('.country-selector__container');
  countrySelectorContainers.forEach((container) => {
    const button = container.querySelector('div.default-country');
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      container.classList.toggle('open');
    });
    document.addEventListener('click', function () {
      countrySelectorContainers.forEach((container) => {
        container.classList.remove('open');
      });
    });
  });
});
